import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 1.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667",
      class: "fill-situational-muted"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 5.833A.833.833 0 1 0 10 7.5a.833.833 0 0 0 0-1.667M10.833 10a.833.833 0 0 0-1.667 0v3.333a.833.833 0 0 0 1.667 0z",
      class: "fill-background-neutral-secondary"
    }, null, -1)
  ])))
}
export default { render: render }